<template>
  <WithTitle :title="$t('tab.characteristic')">
    <ProductFullCharacteristics />
  </WithTitle>
</template>

<script>
import WithTitle from '../layouts/WithTitle'
import ProductFullCharacteristics from '../../../components/product/product-page/ProductFullCharacteristics'

export default {
  name: 'ProductCharacterestics',
  components: {
    ProductFullCharacteristics,
    WithTitle
  }
}
</script>

<style scoped>

</style>
